import { SHOW_OVERLAY, CLOSE_OVERLAY } from '../../ActionsConst';

const defaultOverlay = {
  isActive: false,
  overlayName: null,
  overlayContent: null,
};

const overlay = (state = defaultOverlay, action) => {
  switch (action.type) {
    case SHOW_OVERLAY:
      return {
        overlayName: action.overlayName,
        overlayContent: action.overlayContent,
        isActive: true,
      };
    case CLOSE_OVERLAY:
      return defaultOverlay;
    default:
      return state;
  }
};

export default overlay;
